import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
  },
  title: {
    fontSize: 18,
    marginBottom: 20,
    textAlign: 'center',
  },
  content: {
    marginBottom: 10,
  },
});

const PDFTest = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View>
        <Text style={styles.title}>¡TEST PDF FUNCIONA!</Text>
        <Text style={styles.content}>Si ves esto, el PDF se genera correctamente.</Text>
        <Text style={styles.content}>Fecha: {new Date().toLocaleDateString()}</Text>
        <Text style={styles.content}>Hora: {new Date().toLocaleTimeString()}</Text>
        <Text style={styles.content}>El problema no es la generación del PDF.</Text>
      </View>
    </Page>
  </Document>
);

export default PDFTest;